document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hidden-art-product] .ha-form').forEach((form) => {
    const photoSection = form.querySelector('.pa-photo-upload');
    const personalizationSection = form.querySelector('.pa-personalization');
    if (photoSection && personalizationSection) {
      form.insertBefore(photoSection, personalizationSection);
    }
  });

  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });
  }

  document.querySelectorAll('[data-quantity-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(1, Number(input.value || 1) - 1);
    });
  });
  document.querySelectorAll('[data-quantity-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll('.st-bundle-offers').forEach((group) => {
    group.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', () => {
        group.querySelectorAll('label').forEach((label) => label.classList.remove('is-selected'));
        radio.closest('label').classList.add('is-selected');
        const form = group.closest('form');
        const quantity = form && form.querySelector('input[name="quantity"]');
        if (quantity) quantity.value = radio.dataset.bundleQuantity || 1;
      });
    });
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    const mediaItems = [...gallery.querySelectorAll('[data-product-media]')];
    const thumbs = [...gallery.querySelectorAll('[data-media-target]')];
    const stage = gallery.querySelector('.ha-media-list, .st-product-media-list');
    const mobileGallery = window.matchMedia('(max-width: 850px)');
    const showMedia = (index) => {
      if (!mediaItems.length) return;
      const active = (index + mediaItems.length) % mediaItems.length;
      mediaItems.forEach((item, itemIndex) => {
        const selected = itemIndex === active;
        item.classList.toggle('is-active', selected);
        if (!selected) item.querySelectorAll('video').forEach((video) => video.pause());
      });
      thumbs.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === active));
      thumbs[active]?.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (mobileGallery.matches && stage) {
        stage.scrollTo({ left: mediaItems[active].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
      }
    };
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        showMedia(mediaItems.findIndex((item) => item.dataset.productMedia === thumb.dataset.mediaTarget));
      });
    });

    let scrollFrame = 0;
    stage?.addEventListener('scroll', () => {
      if (!mobileGallery.matches) return;
      window.cancelAnimationFrame(scrollFrame);
      scrollFrame = window.requestAnimationFrame(() => {
        const stageCenter = stage.scrollLeft + stage.clientWidth / 2;
        const active = mediaItems.reduce((best, item, index) => {
          const itemCenter = item.offsetLeft - stage.offsetLeft + item.clientWidth / 2;
          return Math.abs(itemCenter - stageCenter) < best.distance ? { index, distance: Math.abs(itemCenter - stageCenter) } : best;
        }, { index: 0, distance: Infinity }).index;
        mediaItems.forEach((item, index) => item.classList.toggle('is-active', index === active));
        thumbs.forEach((button, index) => button.classList.toggle('is-active', index === active));
      });
    }, { passive: true });

    const makeLightbox = () => {
      const modal = document.createElement('div');
      modal.className = 'pa-gallery-lightbox';
      modal.hidden = true;
      modal.innerHTML = `
        <div class="pa-gallery-lightbox-backdrop" data-gallery-close></div>
        <section class="pa-gallery-lightbox-dialog" role="dialog" aria-modal="true" aria-label="Ürün görselleri">
          <button class="pa-gallery-lightbox-close" type="button" data-gallery-close aria-label="Kapat">×</button>
          <div class="pa-gallery-lightbox-stage" data-gallery-lightbox-stage></div>
          <div class="pa-gallery-lightbox-rail" data-gallery-lightbox-rail></div>
        </section>`;
      document.body.appendChild(modal);
      const lightboxStage = modal.querySelector('[data-gallery-lightbox-stage]');
      const rail = modal.querySelector('[data-gallery-lightbox-rail]');
      let activeIndex = 0;

      const render = (index) => {
        activeIndex = (index + mediaItems.length) % mediaItems.length;
        lightboxStage.replaceChildren();
        const source = mediaItems[activeIndex];
        const isComposedPreview = source.classList.contains('pa-preview-cover') || source.classList.contains('pa-netflix-gallery-media');
        const canvas = source.querySelector('canvas:not([hidden])');
        const image = source.querySelector('img:not([hidden])');
        const video = source.querySelector('video');
        if (isComposedPreview) {
          const clone = source.cloneNode(true);
          clone.classList.add('is-active');
          clone.querySelectorAll('input').forEach((input) => input.remove());
          const sourceCanvases = [...source.querySelectorAll('canvas')];
          clone.querySelectorAll('canvas').forEach((copy, canvasIndex) => {
            const original = sourceCanvases[canvasIndex];
            if (!original || original.hidden) return;
            copy.width = original.width;
            copy.height = original.height;
            copy.hidden = false;
            copy.getContext('2d').drawImage(original, 0, 0);
          });
          lightboxStage.appendChild(clone);
        } else if (canvas) {
          const copy = document.createElement('canvas');
          copy.width = canvas.width;
          copy.height = canvas.height;
          copy.getContext('2d').drawImage(canvas, 0, 0);
          lightboxStage.appendChild(copy);
        } else if (image) {
          lightboxStage.appendChild(image.cloneNode(true));
        } else if (video) {
          const copy = video.cloneNode(true);
          copy.controls = true;
          lightboxStage.appendChild(copy);
        } else {
          const clone = source.cloneNode(true);
          clone.classList.add('is-active');
          lightboxStage.appendChild(clone);
        }
        [...rail.children].forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === activeIndex));
      };

      thumbs.forEach((thumb, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', `Görsel ${index + 1}`);
        const image = thumb.querySelector('img');
        if (image) button.appendChild(image.cloneNode(true));
        if (thumb.classList.contains('pa-preview-cover-thumb')) {
          const badge = document.createElement('span');
          badge.textContent = 'ÖN İZLEME';
          button.appendChild(badge);
        }
        button.addEventListener('click', () => render(index));
        rail.appendChild(button);
      });

      const close = () => {
        modal.hidden = true;
        document.body.classList.remove('pa-gallery-lightbox-open');
      };
      modal.querySelectorAll('[data-gallery-close]').forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) close();
        if (event.key === 'ArrowRight' && !modal.hidden) render(activeIndex + 1);
        if (event.key === 'ArrowLeft' && !modal.hidden) render(activeIndex - 1);
      });
      return {
        open(index) {
          render(index);
          modal.hidden = false;
          document.body.classList.add('pa-gallery-lightbox-open');
          modal.querySelector('.pa-gallery-lightbox-close')?.focus();
        }
      };
    };

    const lightbox = mediaItems.length ? makeLightbox() : null;
    mediaItems.forEach((item, index) => {
      item.classList.add('pa-gallery-zoomable');
      item.addEventListener('click', (event) => {
        if (event.target.closest('button,a,input,label,video')) return;
        lightbox?.open(index);
      });
    });
  });

  document.querySelectorAll('[data-review-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-review-track]');
    const move = (direction) => track.scrollBy({ left: direction * track.clientWidth * 0.82, behavior: 'smooth' });
    slider.querySelector('[data-review-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-review-next]')?.addEventListener('click', () => move(1));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      window.setInterval(() => {
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 10;
        if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' }); else move(1);
      }, 5000);
    }
  });

  document.querySelectorAll('[data-visual-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-visual-track]');
    const move = (direction) => track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.82, 720), behavior: 'smooth' });
    slider.querySelector('[data-visual-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-visual-next]')?.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-category-shelf]').forEach((shelf) => {
    const track = shelf.querySelector('[data-category-track]');
    if (!track) return;
    const focusCards = [...track.querySelectorAll('.st-category-product,.st-category-view-all')];
    let categoryFocusFrame;
    const updateCategoryFocus = () => {
      categoryFocusFrame = null;
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + (trackRect.width / 2);
      let closestCard = null;
      let closestDistance = Infinity;
      focusCards.forEach((item) => {
        const itemRect = item.getBoundingClientRect();
        const distance = Math.abs((itemRect.left + (itemRect.width / 2)) - trackCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestCard = item;
        }
      });
      focusCards.forEach((item) => item.classList.toggle('is-current', item === closestCard));
    };
    const requestCategoryFocus = () => {
      if (categoryFocusFrame) window.cancelAnimationFrame(categoryFocusFrame);
      categoryFocusFrame = window.requestAnimationFrame(updateCategoryFocus);
    };
    track.addEventListener('scroll', requestCategoryFocus, { passive: true });
    window.addEventListener('resize', requestCategoryFocus);
    updateCategoryFocus();
    const move = (direction) => {
      const card = track.querySelector('.st-category-product');
      const trackStyle = window.getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap || trackStyle.gap) || 14;
      const visibleCards = window.matchMedia('(max-width: 1050px)').matches ? 1 : 3;
      const distance = card ? (card.getBoundingClientRect().width + gap) * visibleCards : track.clientWidth * 0.8;
      track.scrollBy({ left: direction * distance, behavior: 'smooth' });
    };
    shelf.querySelector('[data-category-prev]')?.addEventListener('click', () => move(-1));
    shelf.querySelector('[data-category-next]')?.addEventListener('click', () => move(1));
  });

  document.querySelectorAll('[data-hero-slider]').forEach((slider) => {
    const slides = [...slider.querySelectorAll('[data-hero-slide]')];
    const dots = slider.querySelector('[data-hero-dots]');
    const nextButton = slider.querySelector('[data-hero-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const interval = 5000;
    let active = 0;
    let autoTimer;
    if (!slides.length) return;
    slides.forEach((_, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Banner ${index + 1}`);
      dot.addEventListener('click', () => show(index));
      dots.appendChild(dot);
    });
    const dotButtons = [...dots.children];
    const restartTimer = () => {
      window.clearTimeout(autoTimer);
      nextButton?.classList.remove('is-counting');
      void nextButton?.offsetWidth;
      if (reducedMotion) return;
      nextButton?.classList.add('is-counting');
      autoTimer = window.setTimeout(() => show(active + 1), interval);
    };
    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      dotButtons.forEach((dot, i) => dot.classList.toggle('is-active', i === active));
      restartTimer();
    };
    slider.querySelector('[data-hero-prev]')?.addEventListener('click', () => show(active - 1));
    nextButton?.addEventListener('click', () => show(active + 1));
    let touchStart = 0;
    slider.addEventListener('touchstart', (event) => { touchStart = event.changedTouches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', (event) => {
      const distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 45) show(active + (distance < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  });

  document.querySelectorAll('[data-social-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-social-track]');
    const move = (direction) => track.scrollBy({ left: direction * Math.min(track.clientWidth * 0.85, 700), behavior: 'smooth' });
    slider.querySelector('[data-social-prev]')?.addEventListener('click', () => move(-1));
    slider.querySelector('[data-social-next]')?.addEventListener('click', () => move(1));
  });

  const drawer = document.querySelector('[data-mobile-drawer]');
  const drawerOverlay = document.querySelector('[data-drawer-overlay]');
  const drawerOpen = document.querySelector('[data-drawer-open]');
  const drawerClose = document.querySelector('[data-drawer-close]');
  const setDrawer = (open) => {
    if (!drawer || !drawerOverlay) return;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    drawerOverlay.hidden = !open;
    drawerOpen?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('st-drawer-open', open);
  };
  drawerOpen?.addEventListener('click', () => setDrawer(true));
  drawerClose?.addEventListener('click', () => setDrawer(false));
  drawerOverlay?.addEventListener('click', () => setDrawer(false));
  drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setDrawer(false)));

  document.querySelectorAll('[data-show-more-products]').forEach((button) => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.st-product-more').forEach((product) => product.classList.add('is-revealed'));
      button.hidden = true;
      button.parentElement.querySelector('[data-all-products-link]')?.removeAttribute('hidden');
    });
  });

  document.querySelectorAll('.st-announcement-track,.st-marquee-track').forEach((track) => {
    const groups = [...track.querySelectorAll('.st-announcement-group,.st-marquee-group')];
    if (groups.length < 2) return;
    const original = groups[0].innerHTML;
    let repetitions = 0;
    while (groups[0].scrollWidth < (window.innerWidth * 1.35) && repetitions < 8) {
      groups[0].insertAdjacentHTML('beforeend', original);
      repetitions += 1;
    }
    groups[1].innerHTML = groups[0].innerHTML;
  });

  if ('IntersectionObserver' in window) {
    const reviewObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => entry.target.classList.toggle('is-current', entry.isIntersecting && entry.intersectionRatio > 0.72));
    }, { root: null, threshold: [0.72] });
    document.querySelectorAll('.st-reviews blockquote,.st-social-card').forEach((review) => reviewObserver.observe(review));
  }

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.st-reviews').forEach((track) => {
      let paused = false;
      const advance = () => {
        if (paused || track.scrollWidth <= track.clientWidth + 8) return;
        const card = track.querySelector('.st-social-card,blockquote');
        const step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.82;
        const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 12;
        track.scrollTo({ left: atEnd ? 0 : track.scrollLeft + step, behavior: 'smooth' });
      };
      window.setInterval(advance, 3000);
      track.addEventListener('touchstart', () => { paused = true; }, { passive: true });
      track.addEventListener('touchend', () => { window.setTimeout(() => { paused = false; }, 2500); }, { passive: true });
      track.addEventListener('mouseenter', () => { paused = true; });
      track.addEventListener('mouseleave', () => { paused = false; });
    });
  }

  document.querySelectorAll('[data-hidden-art-product]').forEach((root) => {
    const frameOption = root.querySelector('[data-frame-option]');
    const frameColorOption = root.querySelector('[data-frame-color-option]');
    const normalizeFrame = (value) => String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    if (frameOption && !new URLSearchParams(window.location.search).has('variant')) {
      const framedOnly = root.dataset.frameMode === 'framed-only';
      const preferredFrame = [...frameOption.querySelectorAll('[data-option-value]')].find((button) => {
        const value = normalizeFrame(button.dataset.optionValue);
        return framedOnly ? value === 'cerceveli' : value === 'cercevesiz';
      });
      if (preferredFrame) {
        frameOption.querySelectorAll('[data-option-value]').forEach((button) => button.classList.toggle('is-selected', button === preferredFrame));
        const frameLabel = frameOption.querySelector('[data-selected-label]');
        if (frameLabel) frameLabel.textContent = preferredFrame.dataset.optionValue;
      }
    }
    const syncFrameColors = () => {
      if (!frameOption || !frameColorOption) return;
      const selectedFrame = normalizeFrame(frameOption.querySelector('[data-option-value].is-selected')?.dataset.optionValue);
      frameColorOption.classList.toggle('is-hidden', selectedFrame !== 'cerceveli');
    };
    frameOption?.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', () => window.setTimeout(syncFrameColors, 0)));
    syncFrameColors();

    const variantsNode = root.querySelector('[data-ha-variants]');
    const variantInput = root.querySelector('[data-ha-variant-id]');
    const price = root.querySelector('[data-ha-price]');
    const compare = root.querySelector('[data-ha-compare]');
    const addButton = root.querySelector('[data-ha-add]');
    if (!variantsNode || !variantInput || !addButton) return;

    let variants = [];
    try { variants = JSON.parse(variantsNode.textContent); } catch (error) { return; }
    const normalize = (value) => String(value || '').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const money = (cents) => new Intl.NumberFormat('tr-TR', {
      style: 'currency',
      currency: root.dataset.currency || 'TRY',
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
    const optionGroups = [...root.querySelectorAll('[data-option-index]')];
    const colorGroup = optionGroups.find((group) => normalize(group.dataset.optionName).includes('reng'));
    const frameGroup = optionGroups.find((group) => {
      const name = normalize(group.dataset.optionName);
      return name.includes('cerceve') && !name.includes('reng');
    });

    const selectButton = (button) => {
      const group = button.closest('[data-option-index]');
      group.querySelectorAll('[data-option-value]').forEach((item) => item.classList.toggle('is-selected', item === button));
      const label = group.querySelector('[data-selected-label]');
      if (label) label.textContent = button.dataset.optionValue;
    };
    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-value].is-selected')?.dataset.optionValue || '');
    const updateColorVisibility = () => {
      if (!frameGroup || !colorGroup) return;
      const frame = normalize(frameGroup.querySelector('[data-option-value].is-selected')?.dataset.optionValue);
      const isUnframed = frame.includes('cercevesiz');
      colorGroup.classList.toggle('is-hidden', isUnframed);
      if (!isUnframed) return;
      const neutral = [...colorGroup.querySelectorAll('[data-option-value]')].find((button) => {
        const value = normalize(button.dataset.optionValue);
        return value === 'uygulanmaz' || value === 'yok' || value === 'renksiz';
      });
      if (neutral) selectButton(neutral);
    };
    const updateVariant = () => {
      updateColorVisibility();
      const values = selectedOptions();
      const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));
      if (!variant) {
        variantInput.value = '';
        addButton.disabled = true;
        addButton.querySelector('span').textContent = addButton.dataset.unavailableLabel || 'Bu seçenek mevcut değil';
        return;
      }
      variantInput.value = variant.id;
      if (price) price.textContent = money(variant.price);
      if (compare) {
        const hasComparePrice = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !hasComparePrice;
        compare.textContent = hasComparePrice ? money(variant.compare_at_price) : '';
      }
      addButton.disabled = !variant.available;
      addButton.querySelector('span').textContent = variant.available
        ? (addButton.dataset.addLabel || 'Sepete Ekle')
        : (addButton.dataset.soldOutLabel || 'Tükendi');
      const mediaId = variant.featured_media && variant.featured_media.id;
      if (mediaId && root.dataset.previewCoverEnabled !== 'true' && root.dataset.personalizedTemplate !== 'netflix') {
        root.querySelector(`[data-media-target="${mediaId}"]`)?.click();
      }
      if (window.history?.replaceState) window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}${window.location.hash}`);
    };

    optionGroups.forEach((group) => group.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('click', () => { selectButton(button); updateVariant(); });
    }));
    root.querySelectorAll('.ha-upload-grid input[type="file"]').forEach((input) => {
      input.addEventListener('change', () => {
        const label = input.closest('label');
        const name = label?.querySelector('b');
        label?.classList.toggle('has-file', Boolean(input.files?.length));
        if (name && input.files?.length) name.textContent = input.files[0].name;
      });
    });
    root.querySelectorAll('[data-netflix-photo]').forEach((input) => {
      input.addEventListener('change', () => {
        const preview = root.querySelector('[data-netflix-photo-preview]');
        const photo = input.closest('.pa-netflix-photo');
        if (!preview || !input.files?.length) return;
        if (preview.dataset.objectUrl) URL.revokeObjectURL(preview.dataset.objectUrl);
        const objectUrl = URL.createObjectURL(input.files[0]);
        preview.dataset.objectUrl = objectUrl;
        preview.src = objectUrl;
        preview.hidden = false;
        photo?.classList.add('has-photo');
      });
    });
    root.querySelectorAll('[data-netflix-source]').forEach((input) => {
      const output = root.querySelector(`[data-netflix-output="${input.dataset.netflixSource}"]`);
      if (!output) return;
      const syncNetflixPoster = () => { output.textContent = input.value; };
      input.addEventListener('input', syncNetflixPoster);
      input.addEventListener('change', syncNetflixPoster);
      syncNetflixPoster();
    });
    updateVariant();
  });

  document.querySelectorAll('[data-text-preset]').forEach((preset) => {
    const select = preset.querySelector('select');
    if (!select) return;
    const form = preset.closest('form');
    if (!select || !form) return;
    const findProperty = (name) => form.querySelector(`[name="properties[${CSS.escape(name)}]"]`);
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const custom = option?.hasAttribute('data-preset-custom');
      const text = custom ? '' : (option?.dataset.presetText || '');
      if (preset.dataset.presetMode === 'amor') {
        const title = findProperty('Ana kelime');
        const meaning = findProperty('Tanım metni');
        if (title) {
          title.value = custom ? '' : option.value;
          title.dispatchEvent(new Event('input', { bubbles: true }));
        }
        if (meaning) {
          meaning.value = text;
          meaning.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
      if (preset.dataset.presetMode === 'netflix') {
        const description = findProperty('Film açıklaması');
        if (description) {
          description.value = text;
          description.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    });
    select.dispatchEvent(new Event('change'));
  });

  const placeFaqAfterCustomerPhotos = () => {
    const customerPhotos = document.querySelector('.ha-social');
    const faq = document.querySelector('.ha-page .ha-faq');
    if (!customerPhotos || !faq) return;
    const customerPhotosSection = customerPhotos.closest('.shopify-section');
    if (customerPhotosSection) customerPhotosSection.insertAdjacentElement('afterend', faq);
    else customerPhotos.insertAdjacentElement('afterend', faq);
  };
  placeFaqAfterCustomerPhotos();
  document.addEventListener('shopify:section:load', placeFaqAfterCustomerPhotos);
});
